import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { MapPin } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
interface LocationSelectionSectionProps {
  rentalPointName: string;
  returnPointName: string;
  showReturnPoint: boolean;
  onShowReturnPointChange: (show: boolean) => void;
  isLoading?: boolean;
  // Props to enable selecting rental and return points
  rentalPoints?: Array<{ id: string; name: string }>;
  rentalPointId?: string;
  onRentalPointChange?: (id: string) => void;
  returnPointId?: string;
  onReturnPointChange?: (id: string) => void;
  // Control whether rental point is selectable (default: false for backward compatibility)
  allowRentalPointSelection?: boolean;
}
export const LocationSelectionSection = ({
  rentalPointName,
  returnPointName,
  showReturnPoint,
  onShowReturnPointChange,
  isLoading = false,
  rentalPoints = [],
  rentalPointId,
  onRentalPointChange,
  returnPointId,
  onReturnPointChange,
  allowRentalPointSelection = false
}: LocationSelectionSectionProps) => {
  return <div className="bg-muted/50 rounded-lg border p-4 px-[8px]">
      <h3 className="text-lg font-medium mb-4 flex items-center">
        <MapPin className="mr-2 h-5 w-5 text-blue-600" />
        Пункты проката
      </h3>
      <div className="space-y-4">
        <div>
          <Label htmlFor="rentalPointId">Пункт выдачи</Label>
          {allowRentalPointSelection && onRentalPointChange ? (
            <Select value={rentalPointId || ""} onValueChange={(val) => onRentalPointChange(val)}>
              <SelectTrigger id="rentalPointId">
                <SelectValue placeholder={rentalPointName || "Выберите пункт проката"} />
              </SelectTrigger>
              <SelectContent>
                {rentalPoints.length === 0 ? (
                  <SelectItem value="loading" disabled>
                    Загрузка...
                  </SelectItem>
                ) : (
                  rentalPoints.map((p) => (
                    <SelectItem key={p.id} value={p.id}>
                      {p.name}
                    </SelectItem>
                  ))
                )}
              </SelectContent>
            </Select>
          ) : (
            <Input id="rentalPointId" value={rentalPointName || "Не выбран"} disabled className="bg-background" />
          )}
        </div>
        
        <div className="flex items-center space-x-2">
          <Checkbox id="showReturnPoint" checked={showReturnPoint} onCheckedChange={(v) => onShowReturnPointChange(Boolean(v))} disabled={isLoading} />
          <Label htmlFor="showReturnPoint" className="text-sm">
            Указать другой пункт возврата
          </Label>
        </div>
        
        {showReturnPoint && (
          <div>
            <Label htmlFor="returnPointId">Пункт возврата</Label>
            {onReturnPointChange ? (
              <Select value={returnPointId || ""} onValueChange={(val) => onReturnPointChange(val)}>
                <SelectTrigger id="returnPointId">
                  <SelectValue placeholder={returnPointName || "Выберите пункт возврата"} />
                </SelectTrigger>
                <SelectContent>
                  {rentalPoints.length === 0 ? (
                    <SelectItem value="loading" disabled>
                      Загрузка...
                    </SelectItem>
                  ) : (
                    rentalPoints.map((p) => (
                      <SelectItem key={p.id} value={p.id}>
                        {p.name}
                      </SelectItem>
                    ))
                  )}
                </SelectContent>
              </Select>
            ) : (
              <Input id="returnPointId" value={returnPointName || "Не выбран"} disabled className="bg-background" />
            )}
          </div>
        )}
      </div>
    </div>;
};